import uploadsscholarshipssidebyside03imageshutterstock_2477767447Jpg from "$lib/data/generated/uploads/scholarships/SideBySide 03/image/shutterstock_2477767447.jpg?as=run";

export const uploads = {
  "uploads/scholarships/SideBySide 03/image/shutterstock_2477767447.jpg": uploadsscholarshipssidebyside03imageshutterstock_2477767447Jpg
};